import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { FileUploadService } from '../shared/service/file-upload.service';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Tours } from '../shared/model/tours';
import { AdminToursService } from '../shared/service/admin-tours.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AdminDestinationService } from '../shared/service/admin-destination.service';
import { Route, Router } from '@angular/router';
import { AutoLogoutService } from '../shared/service/auto-logout.service';
import { CommonService } from '../shared/service/common.service';
import { environment } from 'src/environments/environment';
import { forEach } from '@angular/router/src/utils/collection';
import { enterView } from '@angular/core/src/render3/state';
declare var $: any;
const LOCAL_USER_KEY = "UserName";
const STORE_KEY = 'lastAction';
@Component({
  selector: 'app-admin-tours',
  templateUrl: './admin-tours.component.html',
  styleUrls: ['./admin-tours.component.css']
})
export class AdminToursComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] = ['TourName', 'TourType', 'BusType', 'BusACType', 'TourImage', 'Destinations', 'StartDate', 'EndDate', 'TourDays', 'TourManager', 'TourCurrentDest', 'TourDetails', 'Edit', 'Delete'];
  LocalToken: string = '';
  toursArr = [];
  dataSource: any;
  imageBaseUrl: string = environment.imageBaseUrl;
  serviceBaseUrl:string = environment.serviceBaseUrl;
  imagePath: string;

  constructor(private adminToursService: AdminToursService, private dialog: MatDialog, private router: Router, private autoLogoutService: AutoLogoutService) {
    localStorage.setItem(STORE_KEY, Date.now().toString());
    this.autoLogoutService.check();
    this.autoLogoutService.initListener();
    this.autoLogoutService.initInterval();
  }

  ngOnInit() {
    this.imagePath = this.imageBaseUrl + "/tours-img/KesaviDefault.jpg";
    this.LocalToken = localStorage.getItem(LOCAL_USER_KEY);
    if (this.LocalToken != null) {
      this.getAllToursDetails();
    }
    else {
      this.router.navigate(["admin/logIn"]);
    }

  }

  getAllToursDetails() {
    this.toursArr = [];
    this.adminToursService
      .getTours()
      .then((result) => {
        this.toursArr = result;
        this.dataSource = new MatTableDataSource();
        this.dataSource = new MatTableDataSource(this.toursArr);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      })
      .catch((err) => console.log(err));
  }

  getToursBySelected(toursObj) {
    this.editDialog(toursObj);
  }


  deleteTours(ID) {
    if (this.toursArr.length > 1) {
      if (confirm('Are you sure you want selected item deleted !')) {
        this.adminToursService
          .deleteToursByID(ID)
          .then((result) => this.getAllToursDetails())
          .catch((err) => console.log(err));
      }
    }
  }

  applyTourFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  errorHandler(err: any) {
    console.log(err);
  }

  openDialog() {
    const dialogRef = this.dialog.open(AdminToursDialog, {
      width: '1000px',
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getAllToursDetails();
    });
  }

  editDialog(toursObj) {
    const dialogRef = this.dialog.open(AdminToursDialog, {
      width: '1000px',
      data: JSON.parse(JSON.stringify(toursObj))
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getAllToursDetails();
    });
  }

}


// Dialoag Component

@Component({
  selector: 'admin-tours-dialog',
  templateUrl: 'admin-tours-dialog.html',
})
export class AdminToursDialog {
  @BlockUI() blockUI: NgBlockUI;
  isUpdate: boolean = false;
  destinationArr: any = [];
  filesArray;
  removeFileArr = [];
  fileListObj: FileList;
  toursDays: number = 0;
  toursNights: number = 0;
  tourDaysNight: any;
  destinationSelect = [];
  minDate: Date;
  constructor(
    public dialogRef: MatDialogRef<AdminToursDialog>,
    @Inject(MAT_DIALOG_DATA) public data: Tours, private adminDestinationService: AdminDestinationService, private fileUploadService: FileUploadService, private adminToursService: AdminToursService, private commonService: CommonService) {
    if (this.data.Id) {
      this.isUpdate = true;
      if (this.data.TourImage) {
        this.removeFileArr = this.data.TourImage.split(",");
      }
      if (this.data.TourDays) {
        this.tourDaysNight = this.data.TourDays.split(" ");
        this.toursDays = this.tourDaysNight[0];
        this.toursNights = this.tourDaysNight[2];
      }
      if (this.data.Destinations) {
        this.destinationSelect = this.data.Destinations.split(",");
      }
    }
    else {
      this.isUpdate = false;
    }
    this.getDestination();
  }

  isDaysNights(event) {
    this.data.TourDays = this.toursDays + " " + "Days" + " " + this.toursNights + " " + "Nights";
  }

  getDestination() {
    this.adminDestinationService
      .getDestination()
      .then((result) => { this.destinationArr = result; })
      .catch((err) => { console.log(err); });
  }


  addTours() {

    if (this.data.StartDate) {
      this.data.StartDate = new Date(this.data.StartDate.toString());
      let sDate: any;
      sDate = (this.data.StartDate.getMonth() + 1) + "/" + this.data.StartDate.getDate() + "/" + this.data.StartDate.getFullYear();
      this.data.StartDate = sDate;
    }
    if (this.data.EndDate) {
      this.data.EndDate = new Date(this.data.EndDate.toString());
      let eDate: any;
      eDate = (this.data.EndDate.getMonth() + 1) + "/" + this.data.EndDate.getDate() + "/" + this.data.EndDate.getFullYear();
      this.data.EndDate = eDate;
    }
    this.data.Destinations = '';
    if (this.destinationSelect.length > 0) {
      for (let i = 0; i < this.destinationSelect.length; i++) {
        if (i == 0) {
          this.data.Destinations += this.destinationSelect[i];
        }
        else {
          this.data.Destinations += "," + this.destinationSelect[i];
        }
      }
    }
    if (this.data.TourName) {
      this.data.TourName = this.data.TourName.toUpperCase();
    }
    this.blockUI.start('Please wait...');
    if (this.filesArray) {
      this.adminToursService
        .addTours(this.data)
        .then((result) => {
          let folderName = "Tours\\" + result;
          this.fileUploadService.ImageUpload(this.filesArray, folderName).then(() => {
            this.clearControl();
            this.blockUI.stop();
            this.dialogRef.close();
          })
            .catch((err) => this.errorHandler(err));
        })
    }
    else {
      this.adminToursService
        .addTours(this.data)
        .then((result) => {
          this.clearControl();
          this.blockUI.stop();
          this.dialogRef.close();
        })
        .catch((err) => this.errorHandler(err));
    }
  }

  editTours() {
    if (this.data.StartDate) {
      this.data.StartDate = new Date(this.data.StartDate.toString());
      let sDate: any;
      sDate = (this.data.StartDate.getMonth() + 1) + "/" + this.data.StartDate.getDate() + "/" + this.data.StartDate.getFullYear();
      this.data.StartDate = sDate;
    }
    if (this.data.EndDate) {
      this.data.EndDate = new Date(this.data.EndDate.toString());
      let eDate: any;
      eDate = (this.data.EndDate.getMonth() + 1) + "/" + this.data.EndDate.getDate() + "/" + this.data.EndDate.getFullYear();
      this.data.EndDate = eDate;
    }

    this.data.Destinations = '';
    if (this.destinationSelect.length > 0) {
      for (let i = 0; i < this.destinationSelect.length; i++) {
        if (i == 0) {
          this.data.Destinations += this.destinationSelect[i];
        }
        else {
          this.data.Destinations += "," + this.destinationSelect[i];
        }
      }
    }
    if (this.data.TourName) {
      this.data.TourName = this.data.TourName.toUpperCase();
    }
    this.blockUI.start('Please wait...');
    if (this.filesArray) {
      this.adminToursService
        .editTours(this.data)
        .then((result) => {
          let folderName = "Tours\\" + result;
          this.fileUploadService.ImageUpload(this.filesArray, folderName).then(() => {
            this.clearControl();
            this.isUpdate = false;
            this.blockUI.stop();
            this.dialogRef.close();
          })
            .catch((err) => this.errorHandler(err));
        })
    }
    else {
      this.adminToursService
        .editTours(this.data)
        .then((result) => {
          this.clearControl();
          this.isUpdate = false;
          this.blockUI.stop();
          this.dialogRef.close();
        })
        .catch((err) => this.errorHandler(err));
    }
  }

  checkDate() {
    if (this.data.StartDate) {
      this.minDate = new Date(this.data.StartDate.toString());
    }
    if (this.data.EndDate) {
      this.data.EndDate = new Date(this.data.EndDate.toString());
    }
    this.minDate.setDate(this.minDate.getDate() + 1);
    if (this.data.StartDate && this.data.EndDate) {
      var startTime = this.data.StartDate.getTime();
      var endTime = this.data.EndDate.getTime();
      if (startTime > endTime) {
        this.data.EndDate = null;
      }
    }
  }

  getTourDays() {
    if (this.data.StartDate && this.data.EndDate) {
      let startDateTime = new Date(this.data.StartDate).getTime();
      let endDateTime = new Date(this.data.EndDate).getTime();
      let tourDaysTime = endDateTime - startDateTime;
      let tourDays = tourDaysTime / 60000 / 60 / 24;
      this.toursDays = tourDays;
      this.toursNights = tourDays - 1;
      this.data.TourDays = this.toursDays + " " + "Days" + " " + this.toursNights + " " + "Nights";
    }
  }

  clearEndDate() {
    if (!this.data.StartDate) {
      this.data.EndDate = null;
    }
  }

  public docChoose(fileInput: any, category: string) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      this.data.TourImage = "";
      if (category == "ToursImage") {
        if (fileInput.target.files.length > 0) {
          for (let i = 0; i < fileInput.target.files.length; i++) {
            if (this.removeFileArr.length > 0) {
              let temp = this.removeFileArr.filter((result => result == encodeURI(fileInput.target.files[i].name)));
              if (temp.length > 0) {
                if (confirm("File already exists. Do you need to replace ?")) {
                  this.removeFileArr.splice($.inArray(fileInput.target.files[i].name, this.removeFileArr), 1);
                  this.removeFileArr.push(encodeURI(fileInput.target.files[i].name));
                }
              }
              else {
                this.removeFileArr.push(encodeURI(fileInput.target.files[i].name));
              }
            }
            else {
              this.removeFileArr.push(encodeURI(fileInput.target.files[i].name));
            }
          }
        }
      }
    }

    if (this.removeFileArr.length > 0) {
      for (let i = 0; i < this.removeFileArr.length; i++) {
        if (i == 0) {
          this.data.TourImage += this.removeFileArr[i];
        }
        else {
          this.data.TourImage += "," + this.removeFileArr[i];
        }
      }
    }

  }

  fileChange(event, category) {
    this.docChoose(event, category);
    this.fileListObj = event.target.files

    this.filesArray = this.fileListObj;
    // this.fileUploadService.ImageUpload(this.fileListObj);
    // let fileList: FileList = event.target.files;

  }


  isInputNumber(event) {
    var key = window.event ? event.keyCode : event.which;
    if (event.keyCode === 8 || event.keyCode === 46) {
      return true;
    } else if (key < 48 || key > 57) {
      return false;
    } else {
      return true;
    }
  }

  removeFile(event) {
    var itemtoRemove = event.target.outerText;
    if (itemtoRemove) {
      if (confirm('Selected file will deleted permenantly. Are you sure')) {
        if (this.filesArray) {
          if (this.removeFileArr.length > 0) {
            for (let i = 0; i < this.removeFileArr.length; i++) {
              if (this.removeFileArr[i] == itemtoRemove) {
                this.removeFileArr.splice($.inArray(itemtoRemove, this.removeFileArr), 1);
                if (this.data.Id) {
                  let parentFolder = "Tours";
                  this.commonService
                    .FileDelete(this.data.Id, itemtoRemove, parentFolder).then(() => {
                      // console.log("file delete");
                      this.adminToursService
                        .editTours(this.data)
                        .then((result) => {
                          console.log("FileDeleted ", + result);
                        }).catch((err) => this.errorHandler(err));
                    }).catch((err) => this.errorHandler(err));
                }
                break;
              }
            }
          }
          if (this.filesArray.length > 0) {
            for (let i = 0; this.filesArray.length; i++) {
              if (this.filesArray[i].name == itemtoRemove) {
                this.filesArray[i].splice($.inArray(itemtoRemove, this.filesArray), 1);
                this.removeFileArr.splice($.inArray(itemtoRemove, this.removeFileArr), 1);
                if (this.data.Id) {
                  let parentFolder = "Tours";
                  // this.commonService
                  //   .FileDelete(this.data.Id, itemtoRemove, parentFolder).then(() => console.log("file delete")).catch((err) => this.errorHandler(err));
                  this.commonService
                    .FileDelete(this.data.Id, itemtoRemove, parentFolder).then(() => {                      
                      this.adminToursService
                        .editTours(this.data)
                        .then((result) => {
                          console.log("FileDeleted ", + result);
                        }).catch((err) => this.errorHandler(err));
                    }).catch((err) => this.errorHandler(err));
                }
                break;
              }
            }
          }
        }
        else {
          if (this.removeFileArr.length > 0) {
            for (let i = 0; i < this.removeFileArr.length; i++) {
              if (this.removeFileArr[i] == itemtoRemove) {
                this.removeFileArr.splice($.inArray(itemtoRemove, this.removeFileArr), 1);
                if (this.data.Id) {
                  let parentFolder = "Tours";
                  // this.commonService
                  //   .FileDelete(this.data.Id, itemtoRemove, parentFolder).then(() => console.log("file delete")).catch((err) => this.errorHandler(err));
                  this.commonService
                    .FileDelete(this.data.Id, itemtoRemove, parentFolder).then(() => {                      
                      this.adminToursService
                        .editTours(this.data)
                        .then((result) => {
                          console.log("FileDeleted ", + result);
                        }).catch((err) => this.errorHandler(err));
                    }).catch((err) => this.errorHandler(err));
                }
                break;
              }
            }
          }
        }

        if (this.removeFileArr.length > 0) {
          this.data.TourImage = "";
          for (let i = 0; i < this.removeFileArr.length; i++) {
            if (i == 0) {
              this.data.TourImage += this.removeFileArr[i];
            }
            else {
              this.data.TourImage += "," + this.removeFileArr[i];
            }
          }
        }
        else {
          this.data.TourImage = null;
        }
      }
    }
  }

  clearControl() {
    this.data
  }

  errorHandler(err: any) {
    console.log(err);
    this.blockUI.stop();
  }

}